import { useEffect, useMemo } from 'preact/hooks';
import { useCachedFetch } from '@core/utils/hooks/use-cached-fetch';
import { useAdminContext } from '../../../context/admin.context';

export function useUserData(requestParams) {
    const endpoint = '/admin/users';

    const { addCacheKey } = useAdminContext();

    const { data, isLoading, error } = useCachedFetch(endpoint, requestParams, {
        enabled: true,
        keepPreviousData: true,
    });

    useEffect(() => {
        addCacheKey('userTable', [endpoint, requestParams]);
    }, [endpoint, requestParams]);

    const tableData = useMemo(() => {
        const items = data?.items || [];
        const total = data?.total || 0;
        return { rows: items, total, isLoading };
    }, [data, isLoading]);

    return { data, error, isLoading, tableData };
}
